import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';

@Injectable()
export class BankMalayReportApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'bankmalayreport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downBankReport(filter: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downBankReport';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) urlParams.filter = filter;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlobWithProgress(method, url, params, urlParams, body);
  }

  public downloadFormatBank(filter: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downloadFormatBank';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) urlParams.filter = filter;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, func, params, body);
  }

  public downloadpublicbank(filter: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downloadpublicbank';
    const params: any = {};
    const urlParams: any = filter;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/bank-malay-report.api.ts